module.exports = __webpack_public_path__ + "static/img/funny_05.04fa9ea8.jpg";